import { styled } from '../../../providers/context/StyletronProvider/withStyletronProvider';

export const LogoContainer = styled('img', {
  maxWidth: '100%',
  maxHeight: '100%',
  objectFit: 'contain',
});
